import styled, { css } from 'styled-components';

interface AnimationContainerProps {
  isVisible?: boolean;
  transitionTimeSeconds: number;
  transitionDelay?: number;
}

const visibleStyles = css`
  visibility: visible;
  opacity: 1;
  transform: translate(0);
`;

const hiddenStyles = css`
  visibility: hidden;
  opacity: 0;
  transform: translate(0, 20px);
`;

export const AnimationContainer = styled.div<AnimationContainerProps>`
  ${({ isVisible }) => (isVisible ? visibleStyles : hiddenStyles)};
  transition: all ${({ transitionTimeSeconds }) => transitionTimeSeconds}s;
  transition-delay: ${({ transitionDelay }) => transitionDelay}ms;
`;
